<template>
  <MainLayout>
    <Head>
      <title>{{ title }}</title>
    </Head>
    <template v-slot:header>
      <span ref="topAnchor">
        {{ title }}
      </span>
    </template>

    <FormWrapper grid>
      <form @submit.prevent="submit">
        <FormInput name="make"
                   v-model="form.make"
                   :errors="errors"
                   class="sm:col-span-3"/>

        <FormInput name="model"
                   v-model="form.model"
                   :errors="errors"
                   class="sm:col-span-3"/>

        <FormInput name="edition"
                   v-model="form.edition"
                   :errors="errors"
                   class="sm:col-span-3"/>

        <div class="sm:col-span-3"></div>

        <FormInput name="start_year"
                   v-model="form.start_year"
                   :errors="errors"
                   class="sm:col-span-3"/>

        <FormInput name="end_year"
                   v-model="form.end_year"
                   :errors="errors"
                   class="sm:col-span-3"/>

        <div class="section">
          <div class="sm:col-span-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Options
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              Set attributes that will be available when creating a new build.
            </p>
          </div>

          <MultiOptionPicker v-for="(item, index) in options"
                             :key="item.id"
                             class="col-span-6"
                             v-model="form.options[index]"
                             :errors="errors"
                             :option="item" />
        </div>

        <FormActions :cancelUrl="$route('vehicles.index')"
                     :show-submit="$can('vehicles.write')"
                     grid />
      </form>
    </FormWrapper>
  </MainLayout>
</template>

<script>
import PageComponent from '@/pages/page-component'
import FormComponent from '@/pages/form-component'
import { Inertia } from '@inertiajs/inertia'
import MultiOptionPicker from '@/components/multi-option-picker.vue'
import UsesPermissions from '@/mixins/uses-permissions'

export default {
  mixins: [
    PageComponent,
    FormComponent,
    UsesPermissions,
  ],

  components: {
    MultiOptionPicker,
  },

  props: {
    model: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    errors: Object,
    options: Array,
  },

  data() {
    return {
      title: `Vehicles :: ${this.model?.name}`,
      form: {
        name: this.model?.name,
        make: this.model?.make,
        model: this.model?.model,
        edition: this.model?.edition,
        start_year: this.model?.start_year,
        end_year: this.model?.end_year,
        options: this.options.map(item => item.selected),
      },
    }
  },

  methods: {
    submit() {
      Inertia.put(this.$route('vehicles.update', [this.model.id]), this.getFormData(), {
        preserveState: true,
        onFinish: () => {
          this.$refs.topAnchor.scrollIntoView()
        }
      })
    },

    getFormData() {
      const { options, ...form } = this.form

      form.options = this.form.options.reduce(
        (carry, selected) => {
          return (selected || []).reduce(
            (carry, item) => ({
              ...carry,
              [item.id]: item,
            }),
            carry,
          )
        },
        {}
      );

      if (! Object.keys(form.options).length) {
        form.options = []
      }

      return form
    }
  }
}
</script>
